import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/assets/css/index.css"
import ViewUIPlus from 'view-ui-plus'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import 'default-passive-events'

const app = createApp(App)


app.use(store)
app.use(router)
app.use(ElementPlus)
app.use(ViewUIPlus)

app.mount('#app')
